import React, { useEffect, useState, useRef } from "react";
import Calendar from '@toast-ui/react-calendar';
import $ from 'jquery';
import moment from 'moment-timezone';
import 'reactjs-popup/dist/index.css';
import Swal from "sweetalert2";
import 'tui-calendar/dist/tui-calendar.css';
import "../../assets/js/rating.js";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import { GetSubjectEventTzCalender } from "../../services/CalendarService.js";
import {
  CampusClass,
  GetClassFiles,
  JoinBBBClass,
  SaveFeedbackRating,
  SaveRecordingAction
} from "../../services/ClassService";
import { getUserSettings } from "../../utils/Auth";
import { getRandomInt, shortenText } from '../../utils/commonFunction.js';
import { AWS_File_URL } from "../../utils/Constants.js";
import { Settings } from "../../utils/CustomModels";
import { download } from "../../utils/FileDownload";
import CalendarListView from "../course/CalendarListView";

 const saveData= (blob,fileName,this_var) => {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";

  var url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  this_var.button('reset');
  Swal.close();
  Swal.fire({
   icon: "success",
   title: "Downloading Finished",
   showConfirmButton: true
 });
}

 const downloadVideo = (url,name,this_var) => {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.onload = function () {
  saveData(this.response, name,this_var); 
  };
  xhr.send();
}

$(document).on("click" , ".watch-video" , function() {
  let id = $(this).attr("class_id");
  let action="view_recording";
  SaveRecordingAction({id,action});
});
let showChar = 220;
let moretext = "Show more";
let lesstext = "Show less";

$(document).on("click" , ".morelink" , function() {
  $(this).removeClass("more").removeClass("morelink");
  $(this).addClass("less").addClass("lesslink");
  $(this).html(lesstext);
  $(this).parents('.meeting-desc').find('.moreellipses').hide();
  $(this).parents('.meeting-desc').find('.morecontent').find('span:first').show();
  return false;
});

$(document).on("click" , ".lesslink" , function() {
  $(this).removeClass("less").removeClass("lesslink");
  $(this).addClass("more").addClass("morelink");
  $(this).parents('.meeting-desc').find('.moreellipses').show();
  $(this).parents('.meeting-desc').find('.morecontent').find('span:first').hide();
  return false;
});

$(document).on("click",".download-video",function() {
  Swal.close();
  Swal.fire({
   icon: "info",
   title: "Downloading Started",
   showConfirmButton: false
 });
  let id = $(this).attr("class_id");
  let action="download_recording";
  let url=$(this).attr("url");
  let name=$(this).attr("name");
  let this_var=$(this);
  this_var.button('loading').queue();
  downloadVideo(url,name,this_var);
  SaveRecordingAction({id,action});
});

$(document).on("click",".class-files",function() {
  let big_blue_button_id = $(this).attr("big_blue_button_id") || $(this).attr("data-big-blue-button-id");
  let this_var=$(this);
  this_var.button('loading').queue();

  GetClassFiles({big_blue_button_id})
  .then((res) => {
    if(res.data.data.Contents.length>0){
      Swal.close();
      res.data.data.Contents.forEach((element,index) => {
        const fileURL = 'https://playback.myaie.ac/' + element.Key;
        const assArray = element.Key.split("/");
        const assArrayLen = assArray.length;
        const fileName = assArray[assArrayLen - 1];

        // This will initiate the download:
        download(fileURL, fileName, fileURL.includes(AWS_File_URL) ? false : true, false);

        Swal.close();
        Swal.fire({
         icon: "info",
         title: index+1+" of "+res.data.data.Contents.length+" are downloading",
         showConfirmButton: false
       });
     });
     Swal.close();
     Swal.fire({
      icon: "success",
      title: "Downloading Finished",
      showConfirmButton: true
    });
    }else{
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "No files available for download",
        showConfirmButton: true
      });
    }
  })
  .catch((error) => {
    Swal.close();
    Swal.fire({
      icon: "error",
      title: "Error while downloading files",
      text: error,
    });
  });
});

const OnlineClasses = ({subjectId}) => {
const [countprev, setprevcount] = useState(1);
const [countnext, setnextcount] = useState(1);
let sD = moment().startOf('week');
let eD = moment().endOf('week');
const [startDateListView, setStartDateListView] = useState(sD);
const [endDateListView, setEndDateListView] = useState(eD);
const [showMonthWeekDate, setShowMonthWeekDate] = useState(false);
const [popupUpdate, setPopupUpdate] = useState(false);
const [workWeek, setWorkWeek] = useState(false);
const [classes, setClasses] = useState([]);
const [todayCalendar, setTodayCalendar] = useState(true);
const [showCalendarLoading, setShowCalendarLoading] = useState(false);

let view='week';
if(Settings.hasOwnProperty("calendar")){
  if(Settings.calendar.defaultView=='list'){
    view='upcoming';
  }else{
    view='week';
  }
}
let userSettings=getUserSettings();
 if(userSettings!==undefined && userSettings!==null){    
   if(Object.keys(userSettings).length!==0){
    if(userSettings.hasOwnProperty("calendar")){
      if(userSettings.calendar.defaultView=='list'){
        view='upcoming';
      }else{
        view='week';
      }
    }
  }
 }
const [calendarView, setCalendarView] = useState(view);
let calendarRef = useRef(null);

const joinVirtualClassGlobal = (id)=>{
  JoinBBBClass({id})
  .then((res) => {
   if(res.data.error==0){
     Swal.close();
     Swal.fire({
      icon: "success",
      title: res.data.title,
      text:res.message,
      showConfirmButton: true
    }).then((result) => {
      if(result.isConfirmed){
        window.open(res.data.url, '_blank');
        let item = res.data.class;
        var foundIndex = classes.findIndex(x => x.id == item.id);
        classes[foundIndex] = item;
        setPopupUpdate(id+getRandomInt(1));
      }
    });
   }else{
     Swal.close();
     Swal.fire({
      icon: "error",
      title: res.data.title,
      text:res.data.message,
      showConfirmButton: true
    })
   }
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Unknown Error.",
    });
  });
}

const joinCampusClassGlobal= (id)=>{
  let action="enter";
  CampusClass({id,action})
  .then((res) => {
   if(res.data.error==0){
     Swal.close();
     Swal.fire({
      icon: "success",
      title: res.data.title,
      text:res.data.message,
      showConfirmButton: true
    }).then((result) => {
      if(result.isConfirmed){
        let item = res.data.class;
        var foundIndex = classes.findIndex(x => x.id == item.id);
        classes[foundIndex] = item;
        setPopupUpdate(id+getRandomInt(2));
      }
    });
   }else{
     Swal.close();
     Swal.fire({
      icon: "error",
      title: res.data.title,
      text:res.data.message,
      showConfirmButton: true
    })
   }
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Unknown Error.",
    });
  });
}

const exitCampusClassGlobal = (id)=>{
  let action="exit";
  CampusClass({id,action})
  .then((res) => {
   if(res.data.error==0){
     Swal.close();
     Swal.fire({
      icon: "success",
      title: res.data.title,
      text:res.data.message,
      showConfirmButton: true
    }).then((result) => {
      if(result.isConfirmed){
        let item = res.data.class;
        var foundIndex = classes.findIndex(x => x.id == item.id);
        classes[foundIndex] = item;
        setPopupUpdate(id+getRandomInt(3));
      }
    });
   }else{
     Swal.close();
     Swal.fire({
      icon: "error",
      title: res.data.title,
      text:res.data.message,
      showConfirmButton: true
    })
   }
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Unknown Error.",
    });
  });
}

const submitRatingGlobal = (id)=>{
  let student_rating= $("#class_rating_"+id).val();
  let student_comment= $("#class_comment_"+id).val();
  SaveFeedbackRating({student_rating,student_comment,id})
  .then((res) => {
    if(res.data.error==0){
      Swal.close();
      Swal.fire({
       icon: "success",
       title: res.data.title,
       text:res.data.message,
       showConfirmButton: true
     }).then((result) => {
       if(result.isConfirmed){
         let item = res.data.class;
         var foundIndex = classes.findIndex(x => x.id == item.id);
         classes[foundIndex] = item;
         setPopupUpdate(getRandomInt(4));
        }
     });
    }else{
      Swal.close();
      Swal.fire({
       icon: "error",
       title: res.data.title,
       text:res.data.message,
       showConfirmButton: true
     })
    }
   })
   .catch((error) => {
      Swal.fire({
       icon: "error",
       title: "Unknown Error.",
      });
   });
}

useEffect(() => {
  $(document).ready(function(){
    $(document).on('click', '.join-virtual-classes', function(e){
      var id = $(this).attr('data-id');
      joinVirtualClassGlobal(id);
    });
    $(document).on('click', '.join-campus-classes', function(e){
      var id = $(this).attr('data-id');
      joinCampusClassGlobal(id);
    });
    $(document).on('click', '.exit-campus-classes', function(e){
      var id = $(this).attr('data-id');
      exitCampusClassGlobal(id);
    });
    $(document).on('click', '.submit-rating-global', function(e){
      var id = $(this).attr('data-id');
      submitRatingGlobal(id);
    });
  });
},[])

var COMMON_CUSTOM_THEME = {
    'common.holiday.color': '#bbb',
    'month.holidayExceptThisMonth.color': '#bbb',
    'week.today.color': '#467fcf',
    'month.schedule.top': '0px',
    'month.schedule.marginTop': '0px',
    'month.schedule.marginLeft': '0px',
    'month.schedule.marginRight': '0px',
    'week.timegridOneHour.height': '45px',
};

const calendarOptions = {
  disableDblClick : true,
  disableClick : true,
  isReadOnly : true,
  taskView: false,
  scheduleView:['time'],
  month: {
    daynames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
  },
  week: {
    daynames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
  },
  theme: COMMON_CUSTOM_THEME, 
  template : {
    time: function(schedule) {
      // Using schedule.raw directly instead of creating a 'raw' alias
      
      if(schedule.raw.canceled){
        return `<div class="meeting-title-box canceled-meeting-title-box">
         <h6 class="meeting-title">${shortenText(schedule.title?.trim(),40)}
          ${schedule.raw.class_type=='hybrid' ? (
            `<span class="d-inline-block"><i class="fal fa-university"></i>
            <i class="fal fa-house-signal"></i></span>`
          ): schedule.raw.class_type=='on_campus' ? (
            `<i class="fal fa-university"></i>`
          )                                                           
          : (
            `<i class="fal fa-house-signal"></i>`
          )}
          </h6>
          <div class="text-overflow-ellipsis">${schedule.raw?.class_description ? shortenText(schedule.raw.class_description?.trim(),25) : ""}</div>
          ${schedule.raw.recurring ? ('<div class="meeting-title-reload"><i class="fal fa-repeat"></i></div>'):('')}
          </div>`;
      }else if(schedule.raw.is_past){
        return `<div class="meeting-title-box past-meeting-title-box">
        <h6 class="meeting-title">${shortenText(schedule.title?.trim(),40)}
        ${schedule.raw.class_type=='hybrid' ? (
         `<span class="d-inline-block"><i class="fal fa-university"></i>
          <i class="fal fa-house-signal"></i></span>`
        ): schedule.raw.class_type=='on_campus' ? (
          `<i class="fal fa-university"></i>`
        )                                                           
        : (
          `<i class="fal fa-house-signal"></i>`
        )}
        </h6>
        <div class="text-overflow-ellipsis">${schedule.raw?.class_description ? shortenText(schedule.raw.class_description?.trim(),25) : ""}</div>
        ${cardRating(schedule.raw.percentage, schedule.raw.student_rating, schedule.raw.student_comment)}
        ${schedule.raw.recurring ? ('<div class="meeting-title-reload"><i class="fal fa-repeat"></i></div>'):('')}
        </div>`;
      }else if(schedule.raw.is_live){
        return `<div class="meeting-title-box live-meeting-title-box">
        <h6 class="meeting-title">${shortenText(schedule.title?.trim(),40)}
        ${schedule.raw.class_type=='hybrid' ? (
          `<span class="d-inline-block"><i class="fal fa-university"></i>
          <i class="fal fa-house-signal"></i></span>`
        ): schedule.raw.class_type=='on_campus' ? (
          `<i class="fal fa-university"></i>`
        ):(
         `<i class="fal fa-house-signal"></i>`
        )}
        </h6>
        <div class="text-overflow-ellipsis">${schedule.raw?.class_description ? shortenText(schedule.raw.class_description?.trim(),25) : ""}</div>
        ${schedule.raw.show_join_button ? '<button title="Join" class="btn btn-success btn-join-title-box"><i class="fal fa-wifi"></i>Join</button>' : ''}
        ${schedule.raw.recurring ? ('<div class="meeting-title-reload"><i class="fal fa-repeat"></i></div>'):('')}
        </div>`;
      }else if(schedule.raw.is_upcoming){
        return `<div class="meeting-title-box upcoming-meeting-title-box">
        <h6 class="meeting-title">${shortenText(schedule.title?.trim(),40)} 
        ${schedule.raw.class_type=='hybrid' ? (
          `<span class="d-inline-block"><i class="fal fa-university"></i>
          <i class="fal fa-house-signal"></i></span>`
        ): schedule.raw.class_type=='on_campus' ? (
          `<i class="fal fa-university"></i>`
        )                                                           
        :(
          `<i class="fal fa-house-signal"></i>`
        )}
        </h6>
        <div class="text-overflow-ellipsis">${schedule.raw?.class_description ? shortenText(schedule.raw.class_description?.trim(),25) : ""}</div>
        ${schedule.raw.recurring ? ('<div class="meeting-title-reload"><i class="fal fa-repeat"></i></div>'):('')}
        </div>`;
      }
    },

    popupDetailBody:function(model){
      // Using model.raw directly instead of creating a 'raw' alias

      if(model.raw.canceled){
        return `<div class="meeting-detail-box canceled-meeting-detail-box">
        <h6>Class has been cancelled</h6>
        <div class="row">
        ${model.raw.recordings!='' && model.raw.recordings!=null ? (`
        <div class="col-12 meeting-btns-col">
        <hr/>
          <div class="meeting-btns">
            <ul class="meeting-btns-list">
            ${model.raw.recordings}
            </ul>
          </div>
        </div>`):(``)
        }
        </div>
        </div>`;
      }else if(model.raw.is_past){
        return `<div class="meeting-detail-box past-meeting-detail-box">
          ${model.raw.class_type=='hybrid' ? ( 
            `<label class="label label-orange">
            <i class="fal fa-university"></i>
            <i class="fal fa-plus"></i>
            <i class="fal fa-house-signal"></i>
            Hybrid
            </label> `
          )
          : model.raw.class_type=='on_campus' ? (
            `<label class="label label-purple">
            <i class="fal fa-university"></i>
            On Campus
            </label> `
          )                                                           
          : (`<label class="label label-green">
            <i class="fal fa-house-signal"></i>
            Virtual
            </label>`)}
            
            <h6>${model.title}</h6>
            <ul class="fa-ul meeting-detail-list">
              <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
              ${model.raw.campus_name_room}
            </ul> 
            <hr/>
            <div class="row">
                ${model.raw.percentage>="1" ? (`
                <div class="col-12 meeting-info-status-col">
                  <span class="green-color">Present 
                  ${model.raw.join_type=='campus' ? (`
                  (on Campus)`):(`(Online)`)
                  }
                  </span>    
                  <span>${model.raw.duration} (${model.raw.percentage}%)</span>    
                  <span>I: ${model.raw.student_time_in}  O: ${model.raw.student_time_out}</span>
                </div>
                ${model.body}
                `):
                (`<div class="col-12 meeting-info-status-col">
                  <span class="red-color">Absent</span>
                  <span>${model.raw.duration} (${model.raw.percentage}%)</span>   
                  <span>I: ${model.raw.student_time_in}  O: ${model.raw.student_time_out}</span>
                </div>`)}
              ${model.raw.recordings!='' && model.raw.recordings!=null ? (`
              <div class="col-12 meeting-btns-col">
              <hr/>
                <div class="meeting-btns">
                   <ul class="meeting-btns-list">
                   ${model.raw.recordings}
                  </ul>
                </div>
              </div>`):(``)
              }
            </div>
            ${model.raw?.class_description ? (`
            <hr/>
            <div class="meeting-desc more">
            ${model.raw.class_description?.trim()}
            </div>`):('')}  
            ${model.raw.Firstname!==null ?(`
            <div class="meeting-instructor">
            <hr/>
            <p class="instructor-name"><i class="fal fa-chalkboard-teacher"></i>${model.raw.Firstname} ${model.raw.Lastname}</p>
            </div>`):('')}  
          </div>`;

      }else if(model.raw.is_live){
        return `<div class="meeting-detail-box upcoming-meeting-detail-box">
          ${model.raw.class_type=='hybrid' ? ( 
            `<label class="label label-orange">
            <i class="fal fa-university"></i>
            <i class="fal fa-plus"></i>
            <i class="fal fa-house-signal"></i>
            Hybrid
            </label>  
            <h6>${model.title}</h6>
            <ul class="fa-ul meeting-detail-list">
              <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
              ${model.raw.campus_name_room}
              </ul> 
            <hr/>
            <div class="btn-square">
            ${model.raw.show_join_button ? 
              `<button data-id="${model.raw.id}" title="Join the class virtually if you are not on campus." class="btn btn-primary join-virtual-classes join-virtual-class">
                <i class="fal fa-house-signal"></i>
                <span class="btn-text">Join Virtual Class</span>
              </button>` : ''
            }
            ${model.raw.show_campus_checkin ? 
              `<button data-id="${model.raw.id}" title="Check in here if you are attending the class on campus." class="btn btn-primary join-campus-class join-campus-classes">
                <i class="fal fa-university"></i>
                <span class="btn-text">Check In On Campus</span>
              </button>` : ''
            }
            ${model.raw.show_campus_checkout ? 
              `<button data-id="${model.raw.id}" title="On Campus Check Out" class="btn exit-campus-class exit-campus-classes">
                <i class="fal fa-window-close" aria-hidden="true"></i>
                <span class="btn-text">On Campus Check Out</span>
              </button>` : ''
            }
            </div>`
          )
          : model.raw.class_type=='on_campus' ? (
            `<label class="label label-purple">
            <i class="fal fa-university"></i>
            On Campus
            </label>  
            <h6>${model.title}</h6>
            <ul class="fa-ul meeting-detail-list">
              <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
              ${model.raw.campus_name_room}
            </ul> 
            <hr/>
            <div class="btn-square">
            ${model.raw.show_campus_checkin ? 
              `<button data-id="${model.raw.id}" title="Check in here if you are attending the class on campus." class="btn btn-primary join-campus-class join-campus-classes">
                <i class="fal fa-university"></i>
                <span class="btn-text">Check In On Campus</span>
              </button>` : ''
            }
            ${model.raw.show_campus_checkout ? 
              `<button data-id="${model.raw.id}" title="On Campus Check Out" class="btn exit-campus-class exit-campus-classes">
                <i class="fal fa-window-close" aria-hidden="true"></i>
                <span class="btn-text">On Campus Check Out</span>
              </button>` : ''
            }
            </div>`
          )                                                           
          : (`<label class="label label-green">
          <i class="fal fa-house-signal"></i>
          Virtual
          </label>  
          <h6>${model.title}</h6>
          <ul class="fa-ul meeting-detail-list">
          <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
          </ul> 
          <hr/>
          <div class="btn-square">
          ${model.raw.show_join_button ? 
            `<button data-id="${model.raw.id}" title="Join the class virtually if you are not on campus." class="btn btn-primary join-virtual-classes join-virtual-class">
              <i class="fal fa-house-signal"></i>
              <span class="btn-text">Join Virtual Class</span>
            </button>` : ''
          }
          </div>`)
          }
          ${model.raw?.class_description ? (`
          <hr/>
          <div class="meeting-desc more">
          ${model.raw.class_description?.trim()}
          </div>`):('')}  
          ${model.raw.Firstname!==null ?(`
          <div class="meeting-instructor">
          <hr/>
          <p class="instructor-name"><i class="fal fa-chalkboard-teacher"></i>${model.raw.Firstname} ${model.raw.Lastname}</p>
          </div>`):('')}   
          </div>`;
      }else if(model.raw.is_upcoming){
        return `<div class="meeting-detail-box live-meeting-detail-box">
        ${model.raw.class_type=='hybrid' ? ( 
          `<label class="label label-orange">
          <i class="fal fa-university"></i>
          <i class="fal fa-plus"></i>
          <i class="fal fa-house-signal"></i>
          Hybrid
          </label>  
          <h6>${model.title}</h6>
          <ul class="fa-ul meeting-detail-list">
            <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
            ${model.raw.campus_name_room}
            </ul> 
          <hr/>
          <div class="btn-square">
          <button disabled data-id="${model.raw.id}" title="Join the class virtually if you are not on campus." class="btn btn-primary join-virtual-classes join-virtual-class disabled">
            <i class="fal fa-house-signal"></i>
            <span class="btn-text">Join Virtual Class</span>
          </button>
          <button disabled data-id="${model.raw.id}" title="Check in here if you are attending the class on campus." class="btn btn-primary join-campus-class join-campus-classes disabled">
           <i class="fal fa-university"></i>
            <span class="btn-text">Check In On Campus</span>
          </button>
          ${model.raw.show_campus_checkout ? 
            `<button data-id="${model.raw.id}" title="On Campus Check Out" class="btn exit-campus-class exit-campus-classes">
              <i class="fal fa-window-close" aria-hidden="true"></i>
              <span class="btn-text">On Campus Check Out</span>
            </button>` : ''
          }
          </div>`
        )
        : model.raw.class_type=='on_campus' ? (
          `<label class="label label-purple">
          <i class="fal fa-university"></i>
          On Campus
          </label>  
          <h6>${model.title}</h6>
          <ul class="fa-ul meeting-detail-list">
            <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
            ${model.raw.campus_name_room}
          </ul> 
          <hr/>
          <div class="btn-square">
          <button disabled data-id="${model.raw.id}" title="Check in here if you are attending the class on campus." class="btn btn-primary join-campus-class join-campus-classes disabled">
           <i class="fal fa-university"></i>
            <span class="btn-text">Check In On Campus</span>
          </button>
          ${model.raw.show_campus_checkout ? 
            `<button data-id="${model.raw.id}" title="On Campus Check Out" class="btn exit-campus-class exit-campus-classes">
              <i class="fal fa-window-close" aria-hidden="true"></i>
              <span class="btn-text">On Campus Check Out</span>
            </button>` : ''
          }
          </div>`
        )                                                           
        : (`<label class="label label-green">
        <i class="fal fa-house-signal"></i>
        Virtual
        </label>  
        <h6>${model.title}</h6>
        <ul class="fa-ul meeting-detail-list">
        <li><i class="fal fa-li fa-calendar-days"></i>${model.raw.showDate}, ${model.raw.class_from} - ${model.raw.class_to}</li>
        </ul> 
        <hr/>
        <div class="btn-square">
        <button disabled data-id="${model.raw.id}" title="Join the class virtually if you are not on campus." class="btn btn-primary join-virtual-classes join-virtual-class disabled">
        <i class="fal fa-house-signal"></i>
        <span class="btn-text">Join Virtual Class</span>
        </button>
        </div>`)
        }
        ${model.raw?.class_description ? (`
        <hr/>
        <div class="meeting-desc more">
        ${model.raw.class_description?.trim()}
        </div>`):('')}  
        ${model.raw.Firstname!==null ?(`
        <div class="meeting-instructor">
        <hr/>
        <p class="instructor-name"><i class="fal fa-chalkboard-teacher"></i>${model.raw.Firstname} ${model.raw.Lastname}</p>
        </div>`):('')}   
        </div>`;
      }
    }
  },
}
const cardRating=(percentage,val,student_comment)=> {
  if(percentage>="1"){
    let returnValue='';
    let remainingRating=5-val;
    let comment='';
    let classInline='';
    if(val>0){
      classInline='text-overflow-ellipsis';
    }
    returnValue=`<div class="meeting-rating-card mt-1 ${classInline}">
    <span class="stars">`;
     if(val>0){
       for (let index = 1; index <= val; index++) {
         returnValue +=`<i class="fas fa-star"></i>`;
       }
       comment=student_comment?.trim();
     }else{
      comment='Rate this class';
     }
     for (let index = 1; index <= remainingRating; index++) {
       returnValue +=`<i class="fal fa-star"></i>`;
     }
   returnValue+=`</span>`;
   returnValue+=`<span class="ml-2">${comment}</span> </div>`;
   return returnValue;
  }else{
    return ` `;

  }
}
const printStar=(id,val,student_comment,percentage)=> {
  let returnValue=` `;
  let remainingRating=5-val;
  if(val>0){
     returnValue=`<div class="col-12 meeting-rating-start-col m-0">
     <div class="meeting-rating-start d-flex ">
     <span class="stars">`;
      for (let index = 1; index <= val; index++) {
        returnValue +=`<i class="fas fa-star"></i>`;
      }
      for (let index = 1; index <= remainingRating; index++) {
        returnValue +=`<i class="fal fa-star"></i>`;
      }
    returnValue+=`</span></div></div>`;
    returnValue+=`<div class="col-12 meeting-leave-comment-col m-0">
    <span>${student_comment?.trim()}</span> </div>`;
  }else if(percentage>="1"){
      returnValue +=`<div class="col-12 meeting-rating-start-col">
      <div class="meeting-rating-start d-flex">
        <input type="number"  class="rating" id=class_rating_${id} />
        <span class="ml-2">How Was Your Class ?</span>
      </div>
    </div>
    <div class="col-12 meeting-leave-comment-col">
        <div class="meeting-leave-comment">
            <textarea rows="2" class="form-control" placeholder="leave a comment" id=class_comment_${id}></textarea>
            <a class="btn btn-primary submit-rating-global" data-id="${id}">Submit Feedback</a>
        </div>
    </div>`;
  }
  return returnValue;
}

const schedules = [];
const buildSchedule = () => {
  classes && classes.length > 0 && classes.map( item => {
    const date = {
      start:`${item.class_date} ${item.class_from}`,
      end:`${item.class_date} ${item.class_to}`
    }
    let scheduleObj = {
      id: item.id,
      calendarId: '1',
      title: item.class_title,
      category: 'time',
      dueDateClass: '',
      start: date.start,
      end: date.end,
      body:  printStar(item.id,item.student_rating,item.student_comment,item.percentage),
      raw:item
    }
    schedules.push(scheduleObj)
  })
} 

buildSchedule();
useEffect(()=>{
  setHeading()
},[])

const setHeading = () =>{
  let startDate=moment(calendarRef?.current?.calendarInst?.getDateRangeStart()?.toDate()).format("D MMMM 'YY");
  let endDate=moment(calendarRef?.current?.calendarInst?.getDateRangeEnd()?.toDate()).format("D MMMM 'YY");
  if(calendarView=='day'){
    setShowMonthWeekDate(startDate);
  }else{
    setShowMonthWeekDate(startDate+' - '+endDate);
  }
}

const moveToTodayRange = () => {
  calendarRef.current.calendarInst.today()
  setHeading();
  setTodayCalendar(true);
}

const moveToPrevRange = () => {
  calendarRef.current.calendarInst.prev()
  setHeading();
  setTodayCalendar(false);

}
const moveToNextRange = () => {
  calendarRef.current.calendarInst.next()
  setHeading();
  setTodayCalendar(false);

}
const setCalendarViewFunc = (e) => {
  setCalendarView(e.currentTarget.value);
  if(e.currentTarget.value=='upcoming'){
    setShowMonthWeekDate("Upcoming Classes");
  }
  else if(e.currentTarget.value=='past'){
    setShowMonthWeekDate("Past Classes");
  }
  else if(e.currentTarget.value=='month'){
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.changeView(`${e.currentTarget.value}`,true);
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.setOptions({month:{workweek:workWeek}},true);
    setTimeout(() => {
      setHeading()
    }, 0);
  }else if(e.currentTarget.value=='week'){
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.changeView(`${e.currentTarget.value}`,true);
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.setOptions({week:{workweek:workWeek}},true);
    setTimeout(() => {
      setHeading()
    }, 0);
  }else{
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.changeView(`${e.currentTarget.value}`,true);
    setTimeout(() => {
      setHeading()
    }, 0);
  }
}

const setWorkWeekFunc = (e) => {
  setWorkWeek(e.currentTarget.checked);
  if(calendarView=='month'){
    calendarRef.current && calendarRef.current.calendarInst &&  calendarRef.current.calendarInst.setOptions({month:{workweek:e.currentTarget.checked}},true);
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.changeView(`month`,true);
    setTimeout(() => {
      setHeading()
    }, 0);
  }else if(calendarView=='week'){
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.setOptions({week:{workweek:e.currentTarget.checked}},true);
    calendarRef.current && calendarRef.current.calendarInst && calendarRef.current.calendarInst.changeView(`week`,true);
    setTimeout(() => {
      setHeading()
    }, 0);
  }
}

const moveToTodayRangeList = () => {
  setnextcount(1);
  setprevcount(1);
  const startDate = new Date(moment().startOf("week"));
  const endDate = new Date(moment().endOf("week"));
  setShowMonthWeekDate(
    moment(startDate).format("D MMMM 'YY") +
      " - " +
      moment(endDate).format("D MMMM 'YY")
  );
  setCalendarView("today");
  setStartDateListView(moment(startDate).format("YYYY-MM-DD"));
  setEndDateListView(moment(endDate).format("YYYY-MM-DD"));

};

const moveToPrevRangeList = (val) => {
  const startDate = new Date(moment().subtract(val, "weeks").startOf("week"));
  const endDate = new Date(moment().subtract(val, "weeks").endOf("week"));
  setShowMonthWeekDate(
    moment(startDate).format("D MMMM 'YY") +
      " - " +
      moment(endDate).format("D MMMM 'YY")
  );
  setStartDateListView(moment(startDate).format("YYYY-MM-DD"));
  setEndDateListView(moment(endDate).format("YYYY-MM-DD"));
};

const moveToNextRangeList = (val) => {
  const startDate = new Date(moment().add(val, "weeks").startOf("week"));
  const endDate = new Date(moment().add(val, "weeks").endOf("week"));
  setShowMonthWeekDate(
    moment(startDate).format("D MMMM 'YY") +
      " - " +
      moment(endDate).format("D MMMM 'YY")
  );
  setStartDateListView(moment(startDate).format("YYYY-MM-DD"));
  setEndDateListView(moment(endDate).format("YYYY-MM-DD"));
};


useEffect(() => {
  if(subjectId && showMonthWeekDate){
    setShowCalendarLoading(true);
    let isDaily = showMonthWeekDate.toString().includes("-") ? true : false;
    let startDate = moment(isDaily ? showMonthWeekDate.split("-")[0] : showMonthWeekDate).format("YYYY-MM-DD");
    let endDate = moment(isDaily ? showMonthWeekDate.split("-")[1] : showMonthWeekDate).format("YYYY-MM-DD");
    
    const params = {
      sid: [subjectId],
      filter: "classes",
      start_date: startDate,
      end_date: endDate
    }
    GetSubjectEventTzCalender(params).then(res => {
      setClasses(res.data);
      setShowCalendarLoading(false);
    }).catch(error => {
      console.error(error);
      setShowCalendarLoading(false);
    })
  }
},[subjectId, showMonthWeekDate]) 

  useEffect(() => {
    const validViews = ['today', 'upcoming', 'past'];

    if (validViews.includes(calendarView)) {
      includeRatingFunction();
    }
  }, [calendarRef, popupUpdate, calendarView, workWeek]) 

const includeRatingFunction=()=>{
  $('input.rating[type=number], div.rating').each(function () {
    $(this).rating();
  });

  $('.more').each(function() {
    let content = removeTagsFromStr($(this).html());

    if(content.length > showChar) {
      let c = content.substr(0, showChar);
      let h = content.substr(showChar-1, content.length - showChar);
      // Get the Last index of Space
      // or any specified character in place of space
      var index = h.lastIndexOf(" ");

      // returns the string from 0 to specified index
      h = h.substring(0, index);
      let html = c + '<span class="moreellipses">&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink show-cls-custom">' + moretext + '</a></span>';
      $(this).html(html);
    }
  });
}

const removeTagsFromStr = (str) => {
  str = str?.replace(/<[^>]+>/g, " ");
  str = str?.replace(/&amp;/g, "&");
  str = str?.replace(/&nbsp;/g, '');
  if (str === null || str === undefined || str === "") return false;
  else str = str.toString();

  return str.replace(/(<([^>]+)>)/gi, "");
};

  return (
    <>
        {showCalendarLoading && <SkeletonContainer height={getSkeletonHeight(30)} />} 
        { !showCalendarLoading && (calendarView=='today' || calendarView=='past' || calendarView=='upcoming')? (
         <div className="meeting-custom-calendar">
            <div className="button-grp form-group">
            <button title="Today" className={`btn btn-white-bordered ${
                                calendarView == 'today'
                                  ? "active"
                                  : ""
                              }`} id="today-button"  value="today" onClick={() => moveToTodayRangeList()}><i className="fal fa-calendar-day"></i>Today</button>
            {
                calendarView=='today' ? (
                  <button title="Previous" className={`btn btn-white-bordered `}
                   id="prev-button"  value="previous" onClick={() => {
                    setprevcount(countprev + 1);
                    setnextcount(-countprev + 1);
                    moveToPrevRangeList(countprev);
                  }}><i className="far fa-arrow-left"></i></button>
                  )
                  :('')
              }
              {
                calendarView=='today' ? (
                  <button  title="Next"  className={`btn btn-white-bordered`}
                   id="next-button"  value="next"  onClick={() => {
                    setnextcount(countnext + 1);
                    setprevcount(-countnext + 1);
                    moveToNextRangeList(countnext);
                  }}><i className="far fa-arrow-right"></i></button> 
                  )
                  :('')
              }
            <div className="current-date">
              {showMonthWeekDate}
            </div>
            <select  
              className="form-control"  
              onChange={(e) => setCalendarViewFunc(e)}>
              <option value="upcoming" >Upcoming</option> 
              <option value="past" >Past</option> 
              <option value="week">Calendar</option>    
            </select>
            <div className="calendar-view-buttons">
                <button title="Upcoming" className={`btn btn-white-bordered ${
                                calendarView == 'upcoming'
                                  ? "active"
                                  : ""
                              }`} value="upcoming" id="upcoming-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-arrow-right"></i>Upcoming</button>
                <button title="Past" className={`btn btn-white-bordered ${
                                calendarView == 'past'
                                  ? "active"
                                  : ""
                              }`} value="past" id="past-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-history"></i>Past</button> 
                <button title="Calendar"  className={`btn btn-white-bordered ${
                                calendarView == 'week'
                                  ? "active"
                                  : ""
                              }`} value="week" id="weekly-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-calendar-days"></i>Calendar</button>
            </div>
          </div>
          <CalendarListView subjectId={subjectId} status={calendarView} startDateListView={startDateListView} endDateListView={endDateListView}/>
          </div>):
        (
          <div className="meeting-custom-calendar">
            <div className="button-grp form-group">
            <button  title="Today"  className={`btn btn-white-bordered ${
                                todayCalendar == true
                                  ? "active"
                                  : ""
                              }`} id="today-button" onClick={() => moveToTodayRange()}><i className="fal fa-calendar-day"></i>Today</button>
            <button title="Previous"  className="btn btn-white-bordered" id="prev-button" onClick={() => moveToPrevRange()}><i className="far fa-arrow-left"></i></button>
            <button title="Next"  className="btn btn-white-bordered" id="next-button" onClick={() => moveToNextRange()}><i className="far fa-arrow-right"></i></button> 
            <div className="current-date">
              {showMonthWeekDate}
            </div>
            <select  
              className="form-control"  
              onChange={(e) => setCalendarViewFunc(e)}>
              <option value="month">Monthly</option>
              <option value="week" >Week</option> 
              <option value="day" >Daily</option> 
              <option value="upcoming">List</option>    
            </select>
            <div className="calendar-view-buttons">
              <button title="Monthly" className={`btn btn-white-bordered ${
                                calendarView == 'month'
                                  ? "active"
                                  : ""
                              }`} value="month" id="monthly-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-calendar-days"></i>Monthly</button>
              <button  title="Weekly"  className={`btn btn-white-bordered ${
                                calendarView == 'week'
                                  ? "active"
                                  : ""
                              }`} value="week" id="weekly-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-calendar-week"></i>Weekly</button>
              <button  title="Daily"  className={`btn btn-white-bordered ${
                                calendarView == 'day'
                                  ? "active"
                                  : ""
                              }`} value="day" id="daily-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-calendar-day"></i>Daily</button> 
              <button  title="List"  className={`btn btn-white-bordered ${
                                calendarView == 'upcoming'
                                  ? "active"
                                  : ""
                              }`} value="upcoming" id="list-button" onClick={(e) => setCalendarViewFunc(e)}><i className="fal fa-list"></i>List</button> 
            </div>
            <div className="custom-control custom-checkbox text-left">
                <input type="checkbox" className="custom-control-input" onClick={(e) => setWorkWeekFunc(e)} id="exclude-weekend"/>
                <label className="custom-control-label" htmlFor="exclude-weekend">Exclude Weekends</label>
            </div>
          </div>
          <div className="calendar-box">
            <Calendar
              height="600px"
              ref={calendarRef} 
              usageStatistics={true} 
              useCreationPopup={true} 
              useDetailPopup={true} 
              schedules={schedules} 
              onClickSchedule = {()=> includeRatingFunction()} 
              {...calendarOptions} 
            />
          </div>
        </div>)}
      
    </>
  );
};
export default OnlineClasses;
